// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"67d17167","1944":"0c45d3a6","3070":"7d6febe6","7658":"8aa7eecc","9209":"0c45d3a6"}[chunkId] + ".chunk.css";
};